import React, { Component } from 'react';

import { partnerRegister } from "../../api/index";
import LayoutWithHeader from '../../component/layoutWithHeader';
import PageNotFound from '../../component/404';
import { getTenantInfo } from '../../api';
import {checkdomain} from "../../utils/utils";

class Register extends Component{
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      confirmEmail: '',
      regularType: '',
      name: '',
      headlineColor: '',
      pageNotFound: false,
      logo: ''
    };
  }

  componentWillMount() {
    let tenantname = location.hostname.split('.')[0].split('-')[0];
    if (checkdomain(tenantname)) {
      return this.props.history.push("/admin");
      // return this.setState({pageNotFound: true});
    }
    getTenantInfo({}, {headers: {'tenantname': tenantname}})
      .then(res => {
        this.setState({
          regularType: res.data.companyName,
          name: res.data.name,
          logo: res.data.logo,
          headlineColor: res.data.headlineColor
        })
      })
      .catch(err=>{
        console.log(err.data);
        if (err.message && err.message === "The tenant was not found.") {
          this.setState({pageNotFound: true});
        }
      });
  }

  componentDidMount() {
    let handlerSubmit = this.handlerSubmit;
    $("#login-form").validate({
      rules: {
        email: {
          required: true,
          email: true
        },
        confirmEmail:{
          required: true,
          email: true,
          equalTo: "#email"
        }
      },
      messages: {
        email: {
          required: 'Please enter your email address',
          email: 'Please enter a valid email address'
        },
        confirmEmail: {
          required: 'Please enter your email address',
          email: 'Please enter a valid email address',
          equalTo:'Please enter the same email address'
        }
      },
      submitHandler: function(){
        handlerSubmit();
      },
      errorPlacement: function (error, element) {
        error.insertAfter(element.parent());
      }
    });
  }
  handlerSubmit = ()=>{
    let { email, confirmEmail,name } = this.state;
    $("#submitBtn").button('loading');
    partnerRegister({email, confirmEmail}, {headers: {'tenantname': name}})
      .then(res=>{
        if (res.status === "success") {
          $.SmartMessageBox({
            title : "Email notification",
            content : res.message,
            buttons : '[Confirm]'
          }, function(ButtonPress){
            if (ButtonPress === "Confirm") {
              $("#submitBtn").button("reset");
            }
          });
        }
        $("#submitBtn").button('reset');
      })
      .catch(e=>{
        console.log(e);
        $("#submitBtn").button('reset');
      });
  };

  render() {
    let { pageNotFound, logo, headlineColor } = this.state;
    let regularType = this.state.regularType.toUpperCase();
    if (pageNotFound) {
      return <PageNotFound />;
    }
    return (
      <LayoutWithHeader logo={logo}>
        <div id="content" className="container">
          <div className="row" style={{marginTop: 14}}>
            <div className="well col-md-6 col-md-offset-3" style={{padding: 20}}>
              <h1 className="login-header-big tex-color-dangreen text-center"
                  style={{color: headlineColor}}>
                {`${regularType} Alerts Subscription Management`}
              </h1>
              <br/>
              <p className="text-center"
                 style={{color: "#000"}}>
                To subscribe,unsubscribe or modify your subscription,
                <br/>please enter your email address
              </p>
              <div className="col-md-8 col-md-offset-2">
                <div className="well no-padding">
                  <form id="login-form" className="smart-form client-form">
                    <header className="text-center" style={{fontWeight: 400}}>
                      Welcome !
                    </header>
                    <fieldset>
                      <section>
                        <label className="label isos-label">E-mail</label>
                        <label className="input">
                          <i className="icon-append fa fa-user" />
                          <input
                            id="email"
                            type="email"
                            name="email"
                            onChange={v=>this.setState({email: v.target.value})}
                            style={{borderRadius: 5}} />
                          <b className="tooltip tooltip-top-right">
                            <i className="fa fa-user txt-color-teal" />
                            &nbsp;Please enter email address
                          </b>
                        </label>
                      </section>
                      <section>
                        <label className="label isos-label">Repeat Email</label>
                        <label className="input">
                          <i className="icon-append fa fa-user" />
                          <input
                            type="email"
                            name="confirmEmail"
                            onChange={v=>this.setState({confirmEmail: v.target.value})}
                            style={{borderRadius: 5}} />
                          <b className="tooltip tooltip-top-right">
                            <i className="fa fa-user txt-color-teal" />
                            &nbsp;Type your email address again
                          </b>
                        </label>
                      </section>
                    </fieldset>
                    <footer className="text-center">
                      <input
                        id="submitBtn"
                        type="submit"
                        value="Sign Up and Manage your Subscription"
                        className="btn btn-primary btn-lg"
                        data-loading-text="waiting..."
                        style={{
                          float: "none",
                          borderRadius: 5,
                          padding: "0 15px"
                        }}/>
                    </footer>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutWithHeader>
    );
  }
}

export default Register;


// WEBPACK FOOTER //
// ./src/container/register/index.js